import { j as jsxRuntimeExports } from './../../../../ext/react/jsx-runtime.js';
import TWRewardsLogo from './logo-tw-rewards.inline.svg.js';

const TreatsLogo = () => {
    return jsxRuntimeExports.jsx(TWRewardsLogo, { role: "img" });
};

export { TreatsLogo };
//# sourceMappingURL=TreatsLogo.js.map
